<template>
  <v-container fluid class="pa-0 mx-2 pb-4">
    <div v-if="!hasNotifications">
      <h4 class="pt-1">
        No new notifications.
      </h4>
    </div>
    <div v-else class="notification-home-widget">
      <v-btn  @click="clearAllNotifications()" flat class="ma-0 text-link-button" style="float:right"><v-icon class="mr-2">clear_all</v-icon>Clear all</v-btn>
      <NotificationDay v-for="(day, index) in notifications" :key="index" :day="day"></NotificationDay>
      <v-tooltip color="secondary" right>
        <v-btn
          dark icon slot="activator"
          color="secondary" class="ma-2" style="margin-left:1px !important"
          v-if="hasMoreNotifications"
          @click="loadMore">
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
        <span>Load more</span>
      </v-tooltip>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import NotificationDay from "@/components/notifications/NotificationDay"

export default {
  name: "HomepageNotifications",
  components: { NotificationDay },
  computed: {
    ...mapState({
      notifications: state => state.currentUser.recentNotifications,
      userId: state => state.currentUser.me.id
    }),
    hasMoreNotifications() {
      return false // TODO
    },
    hasNotifications() {
      return this.notifications && this.notifications.length > 0
    }
  },
  methods: {
    preferencesRoute: (userId) => `/users/${userId}/Notifications`,
    clearAllNotifications() {
      this.$store.dispatch("clearAllNotifications")
    },
    loadMore() {
      console.log("Get more notifications!")
    }
  }
}
</script>

<style>
  .notification-home-widget {
    margin-top:-20px;
  }
</style>
